import React from 'react';
import HomePostCard from './HomePostCard';
import data from './data.json'

const Home = () => {
  return (
    <div className='home-container mx-auto'>
      {data.posts.map(post => <HomePostCard key={post.id} post={post} />)}
    </div>
  );
};

export default Home;
